import Api from '../../shared/services/api'

const baseUrl = "PackagingMaterials";
export default {
  get(branchId) {
    const params = branchId ? `?branchId=${branchId}` : '';
    return Api().get(`${baseUrl}${params}`);
  },
  getById(id) {
    return Api().get(`${baseUrl}/${id}`);
  },
  add(entity) {
    return Api().post(baseUrl, entity);
  },
  edit(id, entity) {
    return Api().put(`${baseUrl}/${id}`, entity);
  },
  delete(id) {
    return Api().delete(`${baseUrl}/${id}`);
  },
  getSalesReport(params) {
    return Api().get(`${baseUrl}/sales-report`, { params });
  },
  addStock(id, payload) {
    return Api().post(`${baseUrl}/${id}/add-stock`, payload);
  },
  deductStock(id, payload) {
    return Api().post(`${baseUrl}/${id}/deduct-stock`, payload);
  },
  getStockTransactions(id) {
    return Api().get(`${baseUrl}/${id}/stock-transactions`);
  }
}
